import * as React from 'react';

export default function Wood({
  className,
  viewBox = '0 0 16 16',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 16H1C0.447715 16 1.61065e-08 15.5523 0 15V13H4V16ZM10 16H6V8H10V16ZM14 3H15V0C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H14V10H13V16H12V0H14V3ZM2 5H3V0H4V11H0V1C0 0.447715 0.447715 0 1 0H2V5ZM10 6H6V0H10V6Z"
        fill="currentColor"
      />
    </svg>
  );
}
